<template>
    <div>
        <!-- <v-app> -->
            <div id="app">
                <vue-headful :title="pageTitle" :description="pageTitleDescription"/>
                <main-nav></main-nav>
                <section id="app-body">
                    <side-menu></side-menu>
                    <section id="router-view">
                        <transition name="routerAnimation" enter-active-class="animated fadeInDown">
                            <router-view :key="$route.fullPath" class="p-3"/>
                        </transition>
                    </section>
                </section>
                <footer class="page-footer font-small px-3 py-2 bg-light">
                    <div class="row">
                        <div class="col-md-3 col-sm-6 col-6 footer-img-container img-left">
                            <img class="footer-image" src="./assets/logos/EU_SEFdown.png" alt/>
                        </div>
                        <div class="logo-text col-md-6">
                            <p>
                                Проект № BG05SFOP001-3.002 „Иновативни продукти и услуги в обучението, предоставяно от НИП”,
                                осъществяван с финансовата подкрепа на Оперативна програма „Добро управление“, съфинансирана
                                от Европейския съюз чрез Европейския социален фонд приоритетна ос № 3,процедура
                                BG05SFOP001-3.002 - "Повишаване на компетентността на магистратите и съдебните служители
                                чрез ефективно обучение в Националния институт на правосъдието", по Договор№
                                BG05SFOP001-3.002-0002-C01/12.9.2017 г.
                            </p>
                        </div>
                        <div class="col-md-3 col-sm-6 col-6 footer-img-container img-right">
                            <img class="footer-image" src="./assets/logos/logo-bg-center-no-back.png" alt/>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center">
                        <span v-if="hasReleaseReadRights">
                            <router-link :to="'/releaseInfo'" target="_blank">{{ $t('version') }}: {{
                                    version
                                }}</router-link>
                            <!--<button class="btn btn-link" @click="showReleaseInfo">{{ $t('version') }}: 1.0.1</button>-->
                        </span>
                        <span v-else>{{ $t('version') }}: {{ version }}</span>
                    </div>
                </footer>
                <service-worker-notifier />
            </div>
        <!-- </v-app> -->
    </div>
</template>

<script>
import Nav from '@/components/navs/MainNavbar.vue';
import SideMenu from '@/components/sidemenu/SideMenu.vue';
import VueHeadful from 'vue-headful';
import { mapGetters, mapActions } from 'vuex';
import bus from '@/components/sidemenu/event-bus';
import ServiceWorkerNotifier from '@/serviceWorker/ServiceWorkerNotifier.vue';

export default {
    components: {
        'main-nav': Nav,
        'side-menu': SideMenu,
        VueHeadful,
        ServiceWorkerNotifier
    },
    data() {
        return {
            worker: null,
            version: ''
        };
    },
    created() {
        this.$store.dispatch('loadUserPolicies');

        this.bus = bus;
        this.createWorker();

        if (this.$store.getters.isAuthenticated) {
            this.startWorker();
        }

        this.$store.dispatch('setActiveRoute', this.$route);

        this.$store.watch(
            (state, getters) => getters.isAuthenticated,
            (newValue, oldValue) => {
                if (newValue) {
                    this.configureWorker();
                    this.startWorker();
                } else {
                    this.stopWorker();
                }
            }
        );

        this.$store.watch(
            (state, getters) => getters.currentCulture,
            (newValue, oldValue) => {
                this.$moment.locale(newValue);
                this.$router.go();
            }
        );

        this.restoreContext();

        this.$tasksHub.$on('task-addded', this.onTaskAdded);
        this.$tasksHub.$on('task-updated', this.onTaskUpdated);
        this.$tasksHub.$on('task-deleted', this.onTaskDeleted);

        this.$tasksHub.$on('toggle-claim', this.onToggleClaim);

        this.$eventsHub.$on('event-addded', this.onEventAdded);
        this.$eventsHub.$on('event-updated', this.onEventUpdated);
        this.$eventsHub.$on('event-deleted', this.onEventDeleted);

        this.$eventsHub.$on('tempranking-confirmed', this.onTemprankingConfirmed);
        this.$eventsHub.$on('tempranking-rejected', this.onTemprankingRejected);

        this.$eventsHub.$on('subscribe-event-notification', this.onSubscribedForEventNotification);
        this.$eventsHub.$on('unsubscribe-event-notification', this.onUnsubscribedForEventNotification);

        this.$eventsHub.$on('action-log-create', this.onActionLogCreate);

        this.$eventsHub.$on('app-signing-settings-update', this.onAppSigningSettingsUpdate);
    },
    methods: {
        ...mapActions(['restoreContext', 'destroyHubs', 'setReportingServerUrl', 'loadAppSigningSettingsAsync', 'loadCurrentUserClaims', 'loadCurrentUserClaims']),
        loadVersion() {
            this.$http.get('/api/Settings/Version').then(result => {
                if (result) {
                    this.version = result.data;
                }
            });
        },
        createWorker() {
            const url = this.$store.getters.isInProduction
                ? `${this.$store.getters.baseUrl}/dist/workers/tasks.worker.js`
                : `/workers/tasks.worker.js`;
            this.worker = new Worker(url);
            this.worker.onmessage = e => {
                this.$store.dispatch('setUserTasks', e.data);
            };
            this.configureWorker();
        },
        configureWorker() {
            this.worker.postMessage({
                cmd: 'SET',
                url: `${this.$store.getters.baseUrl}/api/Tasks/Assigned/Count`,
                token: this.$store.getters.authToken
            });
        },
        startWorker() {
            this.worker.postMessage({
                cmd: 'START'
            });
        },
        stopWorker() {
            this.worker.postMessage({
                cmd: 'STOP'
            });
        },
        destroyWorker() {
            this.worker.terminate();
            this.worker = null;
        },
        onTaskAdded({ id, title }) {
            this.bus.$emit('task-added', id, title);

            this.$vs.notify({
                title: this.$t('notificationsPopup.taskAdded.title'),
                text: `${title}`,
                color: 'primary',
                time: this.$store.getters.notificationDuration
            });
        },
        onTaskUpdated({ id, title }) {
            this.bus.$emit('task-updated', id, title);

            this.$vs.notify({
                title: this.$t('notificationsPopup.taskUpdated.title'),
                text: `${title}`,
                color: 'primary',
                time: this.$store.getters.notificationDuration
            });
        },
        onTaskDeleted({ id, title }) {
            this.bus.$emit('task-deleted', id, title);

            this.$vs.notify({
                title: this.$t('notificationsPopup.taskDeleted.title'),
                text: `${title}`,
                color: 'primary',
                time: this.$store.getters.notificationDuration
            });
        },
        onEventAdded({ id, eventName, eventCode }) {
            this.bus.$emit('event-added', id, eventName, eventCode);

            this.$vs.notify({
                title: this.$t('notificationsPopup.eventAdded.title'),
                text: `${name}`,
                color: 'primary',
                time: this.$store.getters.notificationDuration
            });
        },
        onEventUpdated({ id, eventName, eventCode }) {
            this.bus.$emit('event-updated', id, eventName, eventCode);

            this.$vs.notify({
                title: this.$t('notificationsPopup.eventUpdated.title'),
                text: `${name}`,
                color: 'primary',
                time: this.$store.getters.notificationDuration
            });
        },
        onEventDeleted({ id, eventName, eventCode }) {
            this.bus.$emit('event-deleted', id, eventName, eventCode);

            this.$vs.notify({
                title: this.$t('notificationsPopup.eventDeleted.title'),
                text: `${name}`,
                color: 'primary',
                time: this.$store.getters.notificationDuration
            });
        },
        onTemprankingConfirmed({ eventName, personName, personNameEn }) {
            this.bus.$emit('tempranking-confirmed', eventName, personName, personNameEn);
        },
        onTemprankingRejected({ eventName, personName, personNameEn }) {
            this.bus.$emit('tempranking-rejected', eventName, personName, personNameEn);
        },
        onSubscribedForEventNotification({ eventName, eventCode, username }) {
            this.bus.$emit('subscribe-event-notification', eventName, eventCode, username);
        },
        onUnsubscribedForEventNotification({ eventName, eventCode, username }) {
            this.bus.$emit('unsubscribe-event-notification', eventName, eventCode, username);
        },
        onActionLogCreate({ userId }) {
            this.bus.$emit('action-log-create', userId);
        },
        getLocaleDataFromDB() {
            const lang = this.$store.getters.currentCulture;
            if (lang) {
                this.$validator.locale = lang; // Защото ако не зарежда от базата default е 'en'
                this.$store
                    .dispatch('loadLanguageAsync', lang)
                    .then(response => {
                        if (this.$i18n && response.locale) {
                            this.$i18n.setLocaleMessage(lang, response.locale);
                            this.$validator.locale = lang;
                        }
                    })
                    .catch(error => {
                        console.error(`Error: loadLanguageAsync(${lang})`);
                    });
            }
        },
        loadUserSettings() {
            this.$store.dispatch('loadUserSettingsAsync');
        },
        loadAppSigningSettings() {
            this.$store.dispatch('loadAppSigningSettingsAsync');
        },
        loadReportingServerUrl() {
            this.$http.get('/api/Settings/ReportingServerUrl').then(result => {
                if (result) {
                    this.setReportingServerUrl(result.data);
                }
            });
        },
        extendValidator() {
            this.$validator.extend('upCaseNum', {
                getMessage: () => this.$t('passworRequirement'),
                validate: value => value.match(/^(?=.*[a-z])(?=.*\d)[A-Za-z\d@$!#%*?&-+<>`~()^=/\\]{6,}$/g) !== null
            });
            this.$validator.extend('confirmPass', {
                getMessage: () => this.$t('passworConfirm'),
                validate: (value, [otherValue]) => value === otherValue
            });
        },
        onAppSigningSettingsUpdate() {
            this.loadAppSigningSettingsAsync();
        },
        async onToggleClaim() {
            await this.$store.dispatch('loadCurrentUserClaims');
        }
    },
    watch: {
        $route: function (to, from) {
            this.$store.dispatch('setSideMenuVisibility', false);
            this.$store.dispatch('setActiveRoute', to);
            this.$store.dispatch('setPageTitle', {
                pageTitle: this.$t(to.meta.title),
                pageTitleDescription: to.meta.titleDescription ? this.$t(to.meta.titleDescription) : ''
            });
        }
    },
    beforeDestroy() {
        this.$tasksHub.$off('task-addded', this.onTaskAdded);
        this.$tasksHub.$off('task-updated', this.onTaskUpdated);
        this.$tasksHub.$off('task-deleted', this.onTaskDeleted);

        this.$tasksHub.$off('toggle-claim', this.onToggleClaim);

        this.$eventsHub.$off('event-addded', this.onEventAdded);
        this.$eventsHub.$off('event-updated', this.onEventUpdated);
        this.$eventsHub.$off('event-deleted', this.onEventDeleted);

        this.$eventsHub.$off('tempranking-confirmed', this.onTemprankingConfirmed);
        this.$eventsHub.$off('tempranking-rejected', this.onTemprankingRejected);

        this.$eventsHub.$off('subscribe-event-notification', this.onSubscribedForEventNotification);
        this.$eventsHub.$off('unsubscribe-event-notification', this.onUnsubscribedForEventNotification);

        this.$eventsHub.$off('action-log-create', this.onActionLogCreate);

        this.$eventsHub.$off('app-signing-settings-update', this.onAppSigningSettingsUpdate);


        this.destroyWorker();
        this.destroyHubs();
        this.$store.dispatch('clearUserPolicies');
    },
    computed: {
        ...mapGetters(['currentRegister']),
        pageTitle() {
            return this.$store.getters.pageTitle;
        },
        pageTitleDescription() {
            return this.$store.getters.pageTitleDescription;
        },
        hasReleaseReadRights() {
            return this.$store.getters.claims.releaseInfo.read;
        }
    },
    mounted() {
        this.loadVersion();
        this.getLocaleDataFromDB();
        this.loadUserSettings();
        this.loadReportingServerUrl();
        this.loadAppSigningSettings();
        this.loadCurrentUserClaims();

        this.extendValidator();
    }
};
</script>

<style lang="scss">
@import '../public/css/bootstrap-material-design.min.css';
@import '../public/css/animate.min.css';

html,
body {
    padding: 0;
    margin: 0;
    height: fit-content;
    min-height: 100%;
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding-top: 3.5rem;
    height: fit-content;
    min-height: 100vh;
    position: relative;
    padding-bottom: 330px;
}

footer {
    position: absolute;
    bottom: 0;
    box-shadow: 0px 0px 10px 0px lightgrey;

    .footer-img-container {
        height: 100px;

        .footer-image {
            max-width: 100%;
            max-height: 100%;
            display: block;
            margin: 0 auto;

        }
    }

    .logo-text {
        order: 3;
        font-size: 0.7em;
        font-style: italic;
    }

    .img-left {
        order: 1;
    }

    .img-right {
        order: 4;
    }
}

@media screen and (max-width: 767px) {
    footer {
        .img-right {
            order: 2;
        }
    }
}

#app-body {
    position: relative;
    height: fit-content;
}

#mainNavbar {
    z-index: 1001 !important;
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
    #app {
        padding-top: 3rem;
        padding-bottom: 330px;
    }
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
    #app {
        padding-top: 3rem;
        padding-bottom: 250px;
    }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
    #app {
        padding-top: 3rem;
        padding-bottom: 250px;
    }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
    #app {
        padding-bottom: 150px;
    }
}

.pointer {
    cursor: pointer;
}

.v--modal-overlay {
    z-index: 1040 !important;
}

.loader {
    border: 8px solid lightgrey;
    border-top: 8px solid #009688cc; /* Green */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    margin: 50px auto;
    animation: spin 1s linear infinite;
}

.smallLoader {
    border: 3px solid lightgrey;
    border-top: 3px solid #009688cc; /* Green */
    border-radius: 50%;
    width: 25px;
    height: 25px;
    margin: auto;
    animation: spin 1s linear infinite;
}

.form-group {
    margin-bottom: 10px;
}

.required::after {
    content: ' *';
    color: #f00;
    font-weight: bold;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.card .card-header.bg-primary {
    padding: 0.75rem 1.25rem !important;
    background-color: #009688cc /* Green */
    !important;
}

/* Kendo grid pager */
.k-pager-numbers .k-state-selected {
    background-color: #009688 /* Green */
    !important;
}

.k-map .k-layer {
    position: relative !important;
}

/* Kendo tabs */
.k-tabstrip-items .k-item.k-state-active::after {
    border-color: #009688 /* Green */
    !important;
}

/* Kendo grid row action buttons */
.vs-button-primary.vs-button-border {
    border: 1px solid rgba(#009688, 1) !important;
    color: rgba(#009688, 1) !important;
}

.no-border {
    border: none !important;
}

.k-grid-norecords-template {
    color: red;
    padding: 5px;
}

/*tab-component customTabs-component*/
.tabs-component {
    margin: 4em 0;
}

.tabs-component-tabs {
    border: solid 1px #ddd;
    border-radius: 6px;
    margin-bottom: 5px;
    overflow-x: auto;
    overflow-y: hidden;
}

@media (min-width: 700px) {
    .tabs-component-tabs {
        border: 0;
        align-items: stretch;
        display: flex;
        justify-content: flex-start;
        margin-bottom: -1px;
        overflow-x: auto;
        overflow-y: hidden;
    }
}

.tabs-component-tab {
    color: #999;
    font-size: 14px;
    font-weight: 600;
    margin-right: 0;
    list-style: none;
}

.tabs-component-tab:not(:last-child) {
    border-bottom: dotted 1px #ddd;
}

.tabs-component-tab:hover {
    color: #666;
}

.tabs-component-tab.is-active {
    color: #000;
}

.tabs-component-tab.is-disabled * {
    color: #cdcdcd;
    cursor: not-allowed !important;
}

@media (min-width: 700px) {
    .tabs-component-tab {
        background-color: #fff;
        border: solid 1px #ddd;
        border-radius: 3px 3px 0 0;
        margin-right: 0.5em;
        transform: translateY(2px);
        transition: transform 0.3s ease;
    }

    .tabs-component-tab.is-active {
        border-bottom: solid 1px #fff;
        z-index: 2;
        transform: translateY(0);
    }
}

.tabs-component-tab-a {
    align-items: center;
    color: inherit;
    display: flex;
    padding: 0.75em 1em;
    text-decoration: none;
}

.tabs-component-panels {
    padding: 2em 0;
}

@media (min-width: 700px) {
    .tabs-component-panels {
        border-top-left-radius: 0;
        background-color: #fff;
        border: solid 1px #ddd;
        border-radius: 0 6px 6px 6px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
        padding: 2em 2em;
    }
}

.vs-dialog-text {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 80vh;
}

.radio-message {
    padding: 3px 3px 3px 5px;
    border-left: 3px solid #03a9f4;
    box-shadow: 1px 1px 1px 1px lightgrey;
    width: fit-content;
}
.radio-message-warning {
    padding: 3px 3px 3px 5px;
    border-left: 3px solid #ff5722;
    box-shadow: 1px 1px 1px 1px lightgrey;
    width: fit-content;
}


.radio-message-danger {
    padding: 3px 3px 3px 5px;
    border-left: 3px solid red;
    box-shadow: 1px 1px 1px 1px lightgrey;
    width: fit-content;
}

.expandable-text {
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
}

th.k-header {
    font-size: 0.85rem !important;
}
</style>
